/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NouveautesRouteImport } from './routes/nouveautes'
import { Route as MesCommissionsRouteImport } from './routes/mes-commissions'
import { Route as MagasinsRouteImport } from './routes/magasins'
import { Route as MaRemunerationRouteImport } from './routes/ma-remuneration'
import { Route as FinanceRouteImport } from './routes/finance'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CommissionsRouteImport } from './routes/commissions'
import { Route as ClassementRouteImport } from './routes/classement'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users.index'
import { Route as TicketsIndexRouteImport } from './routes/tickets.index'
import { Route as PartnersIndexRouteImport } from './routes/partners.index'
import { Route as LeadsIndexRouteImport } from './routes/leads.index'
import { Route as ConfigurationIndexRouteImport } from './routes/configuration.index'
import { Route as UsersInviteRouteImport } from './routes/users.invite'
import { Route as UsersUserIdRouteImport } from './routes/users.$userId'
import { Route as TicketsTicketIdRouteImport } from './routes/tickets.$ticketId'
import { Route as PartnersNewRouteImport } from './routes/partners.new'
import { Route as PartnersPartnerIdRouteImport } from './routes/partners.$partnerId'
import { Route as LeadsNewRouteImport } from './routes/leads.new'
import { Route as LeadsLeadIdRouteImport } from './routes/leads.$leadId'

const NouveautesRoute = NouveautesRouteImport.update({
  id: '/nouveautes',
  path: '/nouveautes',
  getParentRoute: () => rootRouteImport,
} as any)
const MesCommissionsRoute = MesCommissionsRouteImport.update({
  id: '/mes-commissions',
  path: '/mes-commissions',
  getParentRoute: () => rootRouteImport,
} as any)
const MagasinsRoute = MagasinsRouteImport.update({
  id: '/magasins',
  path: '/magasins',
  getParentRoute: () => rootRouteImport,
} as any)
const MaRemunerationRoute = MaRemunerationRouteImport.update({
  id: '/ma-remuneration',
  path: '/ma-remuneration',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceRoute = FinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CommissionsRoute = CommissionsRouteImport.update({
  id: '/commissions',
  path: '/commissions',
  getParentRoute: () => rootRouteImport,
} as any)
const ClassementRoute = ClassementRouteImport.update({
  id: '/classement',
  path: '/classement',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsIndexRoute = TicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersIndexRoute = PartnersIndexRouteImport.update({
  id: '/partners/',
  path: '/partners/',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadsIndexRoute = LeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigurationIndexRoute = ConfigurationIndexRouteImport.update({
  id: '/configuration/',
  path: '/configuration/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersInviteRoute = UsersInviteRouteImport.update({
  id: '/users/invite',
  path: '/users/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersUserIdRoute = UsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsTicketIdRoute = TicketsTicketIdRouteImport.update({
  id: '/tickets/$ticketId',
  path: '/tickets/$ticketId',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersNewRoute = PartnersNewRouteImport.update({
  id: '/partners/new',
  path: '/partners/new',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersPartnerIdRoute = PartnersPartnerIdRouteImport.update({
  id: '/partners/$partnerId',
  path: '/partners/$partnerId',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadsNewRoute = LeadsNewRouteImport.update({
  id: '/leads/new',
  path: '/leads/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadsLeadIdRoute = LeadsLeadIdRouteImport.update({
  id: '/leads/$leadId',
  path: '/leads/$leadId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/classement': typeof ClassementRoute
  '/commissions': typeof CommissionsRoute
  '/dashboard': typeof DashboardRoute
  '/finance': typeof FinanceRoute
  '/ma-remuneration': typeof MaRemunerationRoute
  '/magasins': typeof MagasinsRoute
  '/mes-commissions': typeof MesCommissionsRoute
  '/nouveautes': typeof NouveautesRoute
  '/leads/$leadId': typeof LeadsLeadIdRoute
  '/leads/new': typeof LeadsNewRoute
  '/partners/$partnerId': typeof PartnersPartnerIdRoute
  '/partners/new': typeof PartnersNewRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/users/invite': typeof UsersInviteRoute
  '/configuration/': typeof ConfigurationIndexRoute
  '/leads/': typeof LeadsIndexRoute
  '/partners/': typeof PartnersIndexRoute
  '/tickets/': typeof TicketsIndexRoute
  '/users/': typeof UsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/classement': typeof ClassementRoute
  '/commissions': typeof CommissionsRoute
  '/dashboard': typeof DashboardRoute
  '/finance': typeof FinanceRoute
  '/ma-remuneration': typeof MaRemunerationRoute
  '/magasins': typeof MagasinsRoute
  '/mes-commissions': typeof MesCommissionsRoute
  '/nouveautes': typeof NouveautesRoute
  '/leads/$leadId': typeof LeadsLeadIdRoute
  '/leads/new': typeof LeadsNewRoute
  '/partners/$partnerId': typeof PartnersPartnerIdRoute
  '/partners/new': typeof PartnersNewRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/users/invite': typeof UsersInviteRoute
  '/configuration': typeof ConfigurationIndexRoute
  '/leads': typeof LeadsIndexRoute
  '/partners': typeof PartnersIndexRoute
  '/tickets': typeof TicketsIndexRoute
  '/users': typeof UsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/classement': typeof ClassementRoute
  '/commissions': typeof CommissionsRoute
  '/dashboard': typeof DashboardRoute
  '/finance': typeof FinanceRoute
  '/ma-remuneration': typeof MaRemunerationRoute
  '/magasins': typeof MagasinsRoute
  '/mes-commissions': typeof MesCommissionsRoute
  '/nouveautes': typeof NouveautesRoute
  '/leads/$leadId': typeof LeadsLeadIdRoute
  '/leads/new': typeof LeadsNewRoute
  '/partners/$partnerId': typeof PartnersPartnerIdRoute
  '/partners/new': typeof PartnersNewRoute
  '/tickets/$ticketId': typeof TicketsTicketIdRoute
  '/users/$userId': typeof UsersUserIdRoute
  '/users/invite': typeof UsersInviteRoute
  '/configuration/': typeof ConfigurationIndexRoute
  '/leads/': typeof LeadsIndexRoute
  '/partners/': typeof PartnersIndexRoute
  '/tickets/': typeof TicketsIndexRoute
  '/users/': typeof UsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/classement'
    | '/commissions'
    | '/dashboard'
    | '/finance'
    | '/ma-remuneration'
    | '/magasins'
    | '/mes-commissions'
    | '/nouveautes'
    | '/leads/$leadId'
    | '/leads/new'
    | '/partners/$partnerId'
    | '/partners/new'
    | '/tickets/$ticketId'
    | '/users/$userId'
    | '/users/invite'
    | '/configuration/'
    | '/leads/'
    | '/partners/'
    | '/tickets/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/classement'
    | '/commissions'
    | '/dashboard'
    | '/finance'
    | '/ma-remuneration'
    | '/magasins'
    | '/mes-commissions'
    | '/nouveautes'
    | '/leads/$leadId'
    | '/leads/new'
    | '/partners/$partnerId'
    | '/partners/new'
    | '/tickets/$ticketId'
    | '/users/$userId'
    | '/users/invite'
    | '/configuration'
    | '/leads'
    | '/partners'
    | '/tickets'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/classement'
    | '/commissions'
    | '/dashboard'
    | '/finance'
    | '/ma-remuneration'
    | '/magasins'
    | '/mes-commissions'
    | '/nouveautes'
    | '/leads/$leadId'
    | '/leads/new'
    | '/partners/$partnerId'
    | '/partners/new'
    | '/tickets/$ticketId'
    | '/users/$userId'
    | '/users/invite'
    | '/configuration/'
    | '/leads/'
    | '/partners/'
    | '/tickets/'
    | '/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ClassementRoute: typeof ClassementRoute
  CommissionsRoute: typeof CommissionsRoute
  DashboardRoute: typeof DashboardRoute
  FinanceRoute: typeof FinanceRoute
  MaRemunerationRoute: typeof MaRemunerationRoute
  MagasinsRoute: typeof MagasinsRoute
  MesCommissionsRoute: typeof MesCommissionsRoute
  NouveautesRoute: typeof NouveautesRoute
  LeadsLeadIdRoute: typeof LeadsLeadIdRoute
  LeadsNewRoute: typeof LeadsNewRoute
  PartnersPartnerIdRoute: typeof PartnersPartnerIdRoute
  PartnersNewRoute: typeof PartnersNewRoute
  TicketsTicketIdRoute: typeof TicketsTicketIdRoute
  UsersUserIdRoute: typeof UsersUserIdRoute
  UsersInviteRoute: typeof UsersInviteRoute
  ConfigurationIndexRoute: typeof ConfigurationIndexRoute
  LeadsIndexRoute: typeof LeadsIndexRoute
  PartnersIndexRoute: typeof PartnersIndexRoute
  TicketsIndexRoute: typeof TicketsIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/nouveautes': {
      id: '/nouveautes'
      path: '/nouveautes'
      fullPath: '/nouveautes'
      preLoaderRoute: typeof NouveautesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mes-commissions': {
      id: '/mes-commissions'
      path: '/mes-commissions'
      fullPath: '/mes-commissions'
      preLoaderRoute: typeof MesCommissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/magasins': {
      id: '/magasins'
      path: '/magasins'
      fullPath: '/magasins'
      preLoaderRoute: typeof MagasinsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ma-remuneration': {
      id: '/ma-remuneration'
      path: '/ma-remuneration'
      fullPath: '/ma-remuneration'
      preLoaderRoute: typeof MaRemunerationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance': {
      id: '/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof FinanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/commissions': {
      id: '/commissions'
      path: '/commissions'
      fullPath: '/commissions'
      preLoaderRoute: typeof CommissionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/classement': {
      id: '/classement'
      path: '/classement'
      fullPath: '/classement'
      preLoaderRoute: typeof ClassementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/': {
      id: '/tickets/'
      path: '/tickets'
      fullPath: '/tickets/'
      preLoaderRoute: typeof TicketsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners/': {
      id: '/partners/'
      path: '/partners'
      fullPath: '/partners/'
      preLoaderRoute: typeof PartnersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leads/': {
      id: '/leads/'
      path: '/leads'
      fullPath: '/leads/'
      preLoaderRoute: typeof LeadsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/configuration/': {
      id: '/configuration/'
      path: '/configuration'
      fullPath: '/configuration/'
      preLoaderRoute: typeof ConfigurationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/invite': {
      id: '/users/invite'
      path: '/users/invite'
      fullPath: '/users/invite'
      preLoaderRoute: typeof UsersInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$userId': {
      id: '/users/$userId'
      path: '/users/$userId'
      fullPath: '/users/$userId'
      preLoaderRoute: typeof UsersUserIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/$ticketId': {
      id: '/tickets/$ticketId'
      path: '/tickets/$ticketId'
      fullPath: '/tickets/$ticketId'
      preLoaderRoute: typeof TicketsTicketIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners/new': {
      id: '/partners/new'
      path: '/partners/new'
      fullPath: '/partners/new'
      preLoaderRoute: typeof PartnersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners/$partnerId': {
      id: '/partners/$partnerId'
      path: '/partners/$partnerId'
      fullPath: '/partners/$partnerId'
      preLoaderRoute: typeof PartnersPartnerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leads/new': {
      id: '/leads/new'
      path: '/leads/new'
      fullPath: '/leads/new'
      preLoaderRoute: typeof LeadsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leads/$leadId': {
      id: '/leads/$leadId'
      path: '/leads/$leadId'
      fullPath: '/leads/$leadId'
      preLoaderRoute: typeof LeadsLeadIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ClassementRoute: ClassementRoute,
  CommissionsRoute: CommissionsRoute,
  DashboardRoute: DashboardRoute,
  FinanceRoute: FinanceRoute,
  MaRemunerationRoute: MaRemunerationRoute,
  MagasinsRoute: MagasinsRoute,
  MesCommissionsRoute: MesCommissionsRoute,
  NouveautesRoute: NouveautesRoute,
  LeadsLeadIdRoute: LeadsLeadIdRoute,
  LeadsNewRoute: LeadsNewRoute,
  PartnersPartnerIdRoute: PartnersPartnerIdRoute,
  PartnersNewRoute: PartnersNewRoute,
  TicketsTicketIdRoute: TicketsTicketIdRoute,
  UsersUserIdRoute: UsersUserIdRoute,
  UsersInviteRoute: UsersInviteRoute,
  ConfigurationIndexRoute: ConfigurationIndexRoute,
  LeadsIndexRoute: LeadsIndexRoute,
  PartnersIndexRoute: PartnersIndexRoute,
  TicketsIndexRoute: TicketsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
